import React from 'react'
import Layout from './Layout'
import { useProps } from './useProps'

export const EditSurvey = (params: { surveyId?: App.Survey['id'] }) => {
  return <Layout {...useProps(params.surveyId)} />
}
